import React, { useEffect, useState } from 'react';
import { getRejectedBanksFromLogin } from '../../../common/constants/api';

const RejectedBankLogin = ({ leadId }) => {
  const [showRejectedBankLogins, setRejectedBankLogins] = useState([]);

  useEffect(() => {
    getRejectedBanksFromLogin(leadId)
      .then(res => {
        setRejectedBankLogins(res || []);
      })
      .catch(error => {
        setRejectedBankLogins([]);
      });
  }, []);

  return (
    <React.Fragment>
      {showRejectedBankLogins?.length > 0 && (
        <div className="w-full px-8 font-roboto font-medium text-base text-black-500 mt-6">
          Rejected Bank Logins
          <div className="w-full  overflow-auto">
            <table
              className={`border-0 rounded-md w-full my-3  rounded-md border `}
              style={{ minWidth: '400px' }}
            >
              <thead>
                <tr className="bg-green-900 p-3 font-roboto font-normal font-sm text-white ">
                  <th
                    className="px-2 py-1 font-sm text-left py-2 border border-black-500 "
                    style={{ minWidth: '100px' }}
                  >
                    Bank Name
                  </th>
                  <th
                    className="px-2 py-1 font-sm text-left py-2 border border-black-500 "
                    style={{ minWidth: '100px' }}
                  >
                    Login Date
                  </th>
                  <th className="px-2 py-1 font-sm text-left py-2 border border-black-500 ">
                    Rejection Reason
                  </th>
                </tr>
              </thead>

              <tbody>
                {showRejectedBankLogins?.map(each => (
                  <tr>
                    <td
                      className={`font-roboto font-normal text-black-500 px-3 text-sm border border-black-500 border-solid`}
                    >
                      {each.bankName}
                    </td>
                    <td
                      className={`font-roboto font-normal text-black-500 px-3 text-sm border border-black-500 border-solid `}
                    >
                      {each.loginDate}
                    </td>
                    <td
                      className={`font-roboto font-normal text-black-500 px-3 text-sm border border-black-500 border-solid `}
                    >
                      {each.rejectedReason}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default RejectedBankLogin;
